<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex items-center gap-0.5 mx-3.5 my-1.5 p-0.5 rounded-lg bg-n-slate-2">
    <button
      v-for="(item, index) in items"
      :key="item.key"
      class="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium transition-all duration-150 outline-none"
      :class="
        index === activeTabIndex
          ? 'bg-white dark:bg-n-solid-3 text-n-slate-12 shadow-sm'
          : 'text-n-slate-10 hover:text-n-slate-12'
      "
      @click="onTabChange(index)"
    >
      <span>{{ item.name }}</span>
      <span
        v-if="item.count !== undefined"
        class="text-[10px] min-w-[16px] h-4 leading-4 px-1 rounded-full text-center"
        :class="
          index === activeTabIndex
            ? 'bg-n-brand-50 text-n-brand'
            : 'bg-n-alpha-1 text-n-slate-10'
        "
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
